module.exports = __webpack_public_path__ + "img/20210730_121714.6793090b.jpg";